import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'common/utils/initEnv';
import 'common/store/initMobxConfig';
// 必须在任何业务模块（如 idpBase/store 及其依赖）被 import 之前完成 i18n 资源注册，
// 否则在模块顶层调用 i18n.t(..., { ns: 'idp' }) 的常量会拿到未翻译的原文
import './initLocales';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import AegisV2 from '@tencent/aegis-web-sdk-v2';
import { ErrorBoundary } from '@tencent/semi-ui';
import { defaultConfig, handleBeforeSend } from 'common/utils/aegis';
import JSRuntime from 'common/utils/JSRuntime';
import globalStore, { Provider } from 'idpBase/store';
import RootContainer from './modules/root';
import 'common/styles/main.scss';
import 'tdesign-mobile-react/es/style/index.css';

if (!JSRuntime.isDev) {
  /** 监控报警需要上报的域名 */
  const AEGIS_ASSETS_DOMAINS = [
    JSRuntime.idpSite,
    JSRuntime.cdnUrl,
    'https://turing.captcha',
    'https://captcha.gtimg.com',
  ];

  window.aegis = new AegisV2({
    ...defaultConfig,
    id: JSRuntime.isIntl ? 'SDK-24ac32d9747f10df5bc4' : 'SDK-69d659a949c29ce2ae13',
    onBeforeSend: handleBeforeSend(AEGIS_ASSETS_DOMAINS),
  });
}

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Provider store={globalStore}>
    <HashRouter>
      <ErrorBoundary
        onError={(data) => {
          window.aegis?.report({
            type: 'normal',
            level: AegisV2.logLevel.ERROR,
            msg: data,
          });
        }}
      >
        <RootContainer />
      </ErrorBoundary>
    </HashRouter>
  </Provider>,
);
